class ProgressCircle extends HTMLElement {
    static svg = `
        <svg viewBox="0 0 36 36" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
            <circle fill="transparent" stroke-width="2" opacity="0.2" stroke="currentColor" r="15" cx="18" cy="18" transform="rotate(-90, 18,18)"/>
            <circle class="progress-circle" fill="transparent" stroke-width="2" stroke="currentColor" r="15" cx="18" cy="18" transform="rotate(-90, 18,18)"/>
        </svg>
    `;

    constructor() {
        super();
        this.innerHTML = ProgressCircle.svg;
    }

    connectedCallback() {
        this.progressSvg = this.querySelector('.progress-circle');
        this.scrollProgress();
    }

    scrollProgress() {
        /**
         * Hat tip: https://gomakethings.com/debouncing-events-with-requestanimationframe-for-better-performance/
         */
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;

        // used for debounce
        let timeout;
        const offset = Math.round(this.progressSvg.getTotalLength());

        window.addEventListener('scroll', () => {
            const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

            // If there's a timer, cancel it
            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }

            // Setup the new requestAnimationFrame()
            timeout = window.requestAnimationFrame(() => {
                const scrollPercentage = Math.round((scrollTop / height) * 100);
                this.progressSvg.style.strokeDashoffset = scrollPercentage - offset;
            });
        });
    }
}

customElements.define('progress-circle', ProgressCircle);
